/* eslint-disable no-undefined */
/* eslint-disable max-len */
import React, {useEffect, useState} from 'react';
import {Checkbox, Divider, Form, Input, Popup} from 'semantic-ui-react';
import {availableList} from '../../../constants/availableList';
import {daysDepositList} from '../../../constants/daysDepositList';
import {connect} from 'react-redux';
import './styles.scss';
import {mapListToDropdownList, setInitialCheckValues, updateSelections} from '../../../utils/commonUtils';
import {floatingStateTextList} from '../../../constants/flStateTextList';
import {useAsyncDebounce} from 'react-table';
export const Filter = ({column}) => {
  return <div>{column.canFilter && column.render('Filter')}</div>;
};

const columnsCustom = ['floatingVisible', 'daysInDeposit', 'floatingStateText', 'dealerName', 'actionsId'];

const mapStateToProps = (state) => ({
  'blockTable': state.floatingInventory.blockTable,
  'listDealers': state.dealer.list,
  'isUserTde': state.session.isUserFromTDE,
});

export const FloatingInventoryFilter = connect(mapStateToProps, {})(
  ({'column': {filterValue, setFilter, id}, listDealers, blockTable, isUserTde}) => {
    const listDealersDD = mapListToDropdownList(
      listDealers,
      {
        'keys': ['name'],
        'values': ['name'],
        'texts': ['name'],
      },
      true
    );
    return (
      <>
        {id === 'floatingVisible' &&
          <Form.Select
            placeholder="Buscar..."
            fluid
            selection
            disabled={blockTable}
            className='selector-tiny-size'
            value={filterValue || ''}
            onChange={(e, {value}) => setFilter(value || null)
            }
            options={availableList}
          />
        }
        {id === 'daysInDeposit' &&
          <Form.Select
            placeholder="Buscar..."
            fluid
            selection
            disabled={blockTable}
            className='selector-tiny-size check-filter-deposit'
            value={filterValue?.split('/')[1] || ''}
            defaultValue=''
            onChange={(e, {value}) => setFilter(`/${value ? value.split('/')[0] : null}`)}
            options={daysDepositList}
          />
        }
        {id === 'dealerName' &&
          <Form.Select
            placeholder="Seleccionar..."
            fluid
            selection
            disabled={blockTable}
            className='selector-tiny-size'
            value={filterValue || ''}
            onChange={(e, {value}) => setFilter(value || null)}
            options={listDealersDD}
          />
        }
        {id === 'actionsId' && <span />
        }
        {!columnsCustom.includes(id) &&
          <Input
            disabled={blockTable || ''}
            className='input-custom-small-floating'
            value={filterValue || ''}
            onChange={(e) => {
              setFilter(e.target.value || null);
            }}
          />
        }
      </>
    );
  }
);

export const MultiSelectFilter = connect(mapStateToProps, {})(({'column': {filterValue, setFilter}, isUserTde}) => {
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState(
    setInitialCheckValues(filterValue, isUserTde ? floatingStateTextList.tde : floatingStateTextList.dealer)
  );

  const onChange = useAsyncDebounce((value) => {
    setFilter(value || undefined);
  }, 200);

  const handleOptionChange = (data, textCheckBox) => {
    const selected = updateSelections(data.checked, textCheckBox, values, setValues);
    onChange(selected);
  };
  
  useEffect(() => {
    const filterData = filterValue || (isUserTde ? floatingStateTextList.tde : floatingStateTextList.dealer).map((option) => option.text);
    setValues(setInitialCheckValues(filterData, isUserTde ? floatingStateTextList.tde : floatingStateTextList.dealer));
  }, [filterValue]);

  return (
    <Popup
      content={
        <>
          {
            values.map((option) => {
              return <>
                <Checkbox
                  checked={option.check}
                  label={{'children': <code>{option.text} </code>}}
                  onChange={(e, data) => handleOptionChange(data, option.text)}
                />
                <Divider fitted hidden />
              </>;
            })
          }
        </>
      }
      on='click'
      hoverable
      hideOnScroll
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      onmouseout={() => setOpen(false)}
      open={open}
      position='bottom center'
      trigger={
        <div className='floating-div-input'>
          {(values.filter((value) => value.check)).map((value) => <div className='floating-div-input-item'>{value.shortText || ''}</div>
          )}
        </div>
      }
    />
  );
});
